class CartNotification extends HTMLElement {
    constructor() {
        super();
        this.notification = document.getElementById('cart-notification');
        this.renderContentsOnLoad();
        this.closeTimeoutID = null;
    }
    renderContentsOnLoad() {
        var _this = this;
        fetch(`${window.Shopify.routes.root}?sections=cart-notification-content,cart-notification-crosssell-products`)
        .then((response) => response.json())
        .then((parsedState) => {
            const parsedStateSections = parsedState;
            _this.updateContent(parsedStateSections);
            fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then((parsedState) => {
                window.initFreeshippingGoal(parsedState);
                window.cartCount(parsedState);
            }).catch((e) => {
                console.error(e);
            });

            window.renderCrosssellProducts(parsedStateSections);
        })
        .catch((e) => {
            console.error(e);
        });
    }
    open(autoClose) {
        var _this = this;
        this.notification.classList.add('active');
        document.body.classList.add('minicart-active');
        document.body.style.marginRight = (window.innerWidth - $(window).width())  + 'px';
    }
    close() {
        $('.cart-item__error-text').empty();
        this.notification.classList.remove('active');
        setTimeout(function(){
            document.body.classList.remove('minicart-active');
            document.body.style.marginRight = '0px';
        },300);
        clearTimeout(this.closeTimeoutID);
    }
    renderContents(parsedState) {
        var _this = this;
        const parsedStateSections = parsedState.sections;
        if (parsedStateSections != undefined) {
          _this.updateContent(parsedStateSections);  
        }
        var autoClose = true ;
        if (parsedState.hasOwnProperty('items')) {
            fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then((parsedState) => {
                autoClose = false;
                window.initFreeshippingGoal(parsedState);
                window.cartCount(parsedState);
            }).catch((e) => {
                console.error(e);
            });
        } else {
            fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then((parsedState) => {
                 autoClose = true;
                window.initFreeshippingGoal(parsedState);
                window.cartCount(parsedState);
            }).catch((e) => {
                console.error(e);
            });
        }
        window.renderCrosssellProducts(parsedStateSections); 
        if (window.jQuery) {
        }
        this.open(autoClose);
    }
    updateContent(parsedStateSections) {
        var _this = this;
        this.getSectionsToRender().forEach((section => {
            const parsedStateHtml = new DOMParser().parseFromString(parsedStateSections[section.id], 'text/html');
            
            if (section.id == 'cart-notification-content') {
                if (parsedStateHtml.querySelector('.empty-mini-cart')) {
                    document.getElementById('cart-notification-content').classList.add('h-100');
                } else {
                    document.getElementById('cart-notification-content').classList.remove('h-100');
                }
            }

            if (section.id == 'cart-notification-content' && section.hasOwnProperty('elements') && document.getElementById(section.id).querySelector('[data-mini-cart-wrapper]') && parsedStateHtml.querySelector('[data-mini-cart-wrapper]')) {
                section['elements'].forEach(function(elem) {
                    const content = _this.getSectionInnerHTML(parsedStateSections[section.id], elem);
                    if (content != '') {
                        document.getElementById(section.id).querySelector(elem).classList.remove('d-none');
                        document.getElementById(section.id).querySelector(elem).innerHTML = content;
                    } else {
                        document.getElementById(section.id).querySelector(elem).classList.add('d-none');
                    }
                });
            } else {
                document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedStateSections[section.id]);
            }
        }));
    }
    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-content',
                elements: ['[data-cart-title]', '[data-mini-cart-wrapper]']
            },
            {
                id: 'cart-notification-crosssell-products'
            }
        ];
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        return parsedHtml.querySelector(selector) ? parsedHtml.querySelector(selector).innerHTML : ''; 
    }
    setActiveElement(element) {
        this.activeElement = element;
    }
}
customElements.define('cart-notification', CartNotification);